import {HttpErrorResponse} from "@angular/common/http";

export interface Dto {
    ref: string;
    name: string;
    category?: string;
}

export class EnumDto<T> {
    constructor(public ref: T, public name: string) {}
    static fromEnum<U extends string | number, T>(enumType: Record<U, T>): EnumDto<T>[] {
        return Object.entries(enumType)
                .map(([key, value]) => new EnumDto<T>(key as T, value as string));
    }
}


export function dtosFromEnum(enumType: any): Dto[] {
    return Object.keys(enumType).map(ref => {
        return {ref: ref, name: enumType[ref]}
    });
}


export class Response<T>{
    data: T;
    message: string;
    public static of<T>(http: HttpErrorResponse): Response<T> {
        let response = new Response<T>();
        if (http.error) {
            response.message = http.error.message;
            return response;
        }
        response.message = http.message;
        return response;
    }

    public static empty<T>(): Response<T> {
        return new Response<T>();
    }
}

/**
 * Generic download response for file downloads (CSV, PDF, etc.)
 * Used across multiple modules: PAYE, Pension, Statutory Management
 */
export interface DownloadResponse {
    base64: string;
    fileName?: string;
    fileType?: string;
    fileSize?: number;
}

export class ErrorModel {
    constructor(
            public code: number = 99,
            public message: string = "An error occurred",
            public path: string | null = "",
            public serverError: string = "",
            public status: number = 99,
            public timestamp: Date = new Date()) {
    }

    public static of(http: HttpErrorResponse): ErrorModel {
        let error = new ErrorModel();
        if (http.error) {
            error.code = http.error.code || http.status;
            error.message = http.error.message || http.message;
            error.path = http.error.path || http.url;
            error.serverError = http.error.serverError || http.message;
            error.status = http.error.status || http.status;
            error.timestamp = http.error.timestamp || new Date();
            return error;
        }
        error.code = http.status;
        error.message = http.message;
        error.path = http.url;
        error.serverError = http.message;
        error.status = http.status;
        error.timestamp = new Date();
        return error;
    }

    public static message(message: string): ErrorModel {
        let error = new ErrorModel();
        error.message = message;
        return error;
    }
}

export interface Bank{
    code: string;
    name: string;
}

export class Currency implements Dto{

    static readonly DEFAULT_FORMAT = "₦#,##0.00";
    static readonly DEFAULT: Currency = {
        code: "NGN",
        name: "Naira",
        symbol: "₦",
        format: Currency.DEFAULT_FORMAT,
        ref: "NGN",
        locale: "en-NG"
    }
    code: string;
    name: string;
    symbol: string;
    format: string;
    locale: string;
    get ref(): string {
        return this.code;
    }
}

export class Language implements Dto {
    code: string;
    name: string;
    get ref(): string {
        return this.code;
    }
}

export function snakeToSentenceCase(str: string) : string {
    let val = str.split('_').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ')
    return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
}

/**
 * Create: Save and create another<br>
 * Exit: Save and exit<br>
 * Stay: Save and open saved item
 */
export type SaveAction = 'create' | 'exit' | 'stay'
